import { SiteConfig } from "@mobiusjs/superfon-new-site-client";

SiteConfig.options = require('./config.options').default;

export default {
    ...SiteConfig,
    version: '8.8.31',
    debug: false,
    soon: false,
    prefix: 'sup_',
    name: 'sup_site',
    title: 'Superfon',
    seo: {
        title: {
            az: 'Ürəyin istəyən mobil telefon və aksesuarlar | Superfon.az',
            en: '',
            ru: ''
        },
        desc: {
            az: 'Mobil telefon və aksesuarları, Audio, TV və Avtomobil üçün aksesuarlar, Kompüter ləvazimatları ən sərfəli və ucuz qiymətə Superfon online mağazasında.',
            en: '',
            ru: ''
        }
    },
    directives: {
        connectSrc: [
            "'self'",
            "api.superfon.az", "www.superfon.az",
            "widget.getwhelp.com", "widget-api.getwhelp.com", "wss://widget-server.whelp.co",
            "a7117245770d30cbfca550397e08c3a4.m.pipedream.net",
            "analytics.google.com", "stats.g.doubleclick.net",
            "www.google-analytics.com", "ssl.google-analytics.com",
            "www.google.com", "www.googleadservices.com",
            "googleads.g.doubleclick.net",
            "*.yandex.ru", "*.facebook.com", "*.whelp.co", "wss://socket.whelp.co",
            "pagead2.googlesyndication.com"
        ],
        defaultSrc: [
            "'self'",
            "cdn.getwhelp.com", "widget.getwhelp.com", "*.whelp.co"
        ],
        imgSrc: [
            "'self'", "blob:", "data:",
            "cdn.superfon.az", "www.facebook.com", "connect.facebook.net",
            "img.youtube.com", "i.ytimg.com", "www.youtube.com",
            "a.tile.osm.org", "b.tile.osm.org", "c.tile.osm.org", "api.mapbox.com",
            "widget.getwhelp.com", "cdn.getwhelp.com",
            "www.google-analytics.com", "www.google.az", "www.google.com",
            "ssl.google-analytics.com", "googleads.g.doubleclick.net",
             "www.googleadservices.com",
            "*.yandex.ru", "*.whelp.co"
        ],
        fontSrc: [
            "'self'", "data:", "fonts.gstatic.com", "*.whelp.co"
        ],
        frameSrc: [
            "'self'",
            "www.youtube.com", "www.facebook.com",
            "bid.g.doubleclick.net", "td.doubleclick.net", "mc.yandex.ru", "www.google.com", "www.googleadservices.com"
        ],
        scriptSrc: [
            "'self'", "'unsafe-inline'",
            "connect.facebook.net",
            "www.google-analytics.com", "www.googleadservices.com",
            "googleads.g.doubleclick.net", "www.google.com"
        ],
        styleSrc: [
            "'self'", "'unsafe-inline'",
            "cdnjs.cloudflare.com"
        ]
    },
    modules: {
        library: { ...SiteConfig.modules.library },
        custom: {}
    },
    lang: {
        multiLang: true,
        default: 'az',
        languages: ['az', 'ru']
    },
    company: {
        established: 2019,
        title: 'Superfon'
    },
    settings: {
        chooseGiftPack: false
    },
    ssl: true,
    urls: {
        api: 'api.superfon.az',
        cdn: 'cdn.superfon.az',
        panel: 'panel.superfon.az',
        site: 'www.superfon.az'
    },
    originalSizes: [1080, 1080],
    user: {
        withMobile: true,
        otp: true,
        hasBirthday: false
    },
    google: {
        // tagManagerId: 'GTM-MQWPJVL',
        analyticsId: 'G-QKXRKSETTW',
    },
    facebook: {
        pixelId: '3039237396348052'
    },
    installment: {
        active: true,
        oldPrice: false,
        minAmount: 10,
        cards: {
            birkart: {
                active: true,
                title: 'BirKart',
                months: [3, 6, 9, 12, 18]
            },
            tamkart: {
                active: true,
                title: 'TamKart',
                months: [3, 6, 9, 12, 18]
            }
        },
        rules: [
            {
                productTypeIds: [],
                maxMonth: 6
            }
        ]
    },
    snow: {
        active: false
    },
    price: {
        supCent: false
    },
    withOrangeStar: false,
    with8March: false
};
